import React from 'react';
import { Button, Input, Label, Link, Text, useId } from '@fluentui/react-components';
import { mergeStyleSets } from '@fluentui/react';
import { sharedStyles, styles as WelcomeStyles } from './index';
import { useTranslation } from 'react-i18next';
import useRequestButton from './hooks/useRequestButton';
import { _dataProvider } from '../../dataProvider/DataProvider';

export type ILoginProps = {
  onBackToLogin?: () => void;
  onSuccess?: (params: { email: string }) => void;
};
const ForgetPwd: React.FC<ILoginProps> = (props) => {
  const { onBackToLogin, onSuccess } = props;

  const { t } = useTranslation();
  const inputEmailId = useId('email');
  const { loadingState, setLoadingState, buttonIcon } = useRequestButton();

  const handleSubmit = async (evt: React.FormEvent) => {
    if (loadingState !== 'initial') {
      return;
    }

    evt.preventDefault();
    const form = evt.target as HTMLFormElement;
    const formData = Object.fromEntries(new FormData(form).entries());

    console.log('Login Form Data:', formData);
    const { email } = formData as Record<'email', string>;

    setLoadingState('loading');
    const isSuccess = await resetPassword({ email });
    if (isSuccess) {
      setTimeout(() => {
        onSuccess?.({ email });
      }, 500);
    }
    setLoadingState(isSuccess ? 'loaded' : 'initial');
  };

  const resetPassword = async ({ email }: { email: string }) => {
    try {
      await _dataProvider.resetPassword(email);
      return true;
    } catch (error) {
      alert(error.message || t('PasswordResetError'));
    }

    return false;
  };

  return (
    <div className={sharedStyles.container}>
      <Text as='h3' block className={WelcomeStyles.subTitle}>
        {t('welcome.forgetPassword.title')}
      </Text>
      <Text block className={styles.description}>
        {t('welcome.forgetPassword.titleDescription')}
      </Text>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles['form-item']}>
          <Label htmlFor={inputEmailId}>{t('Email')}</Label>
          <Input
            name='email'
            className={styles['form-ctrl']}
            size='large'
            id={inputEmailId}
            placeholder={t('example')}
            type='email'
            required
          />
        </div>

        <div className={styles['form-item']}>
          <Button className={styles.primaryButton} type='submit' appearance='secondary' size='large' icon={buttonIcon}>
            {t('retrievePwd')}
          </Button>
          <Link style={{ color: '#FF9900', textAlign: 'center' }} onClick={onBackToLogin}>
            {t('welcome.backToLogin')}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default ForgetPwd;

const styles = mergeStyleSets({
  description: {
    whiteSpace: 'nowrap !important',
    fontSize: '12px !important',
    textAlign: 'center !important'
  },

  form: {},

  ['form-item']: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    gap: '4px',
    marginTop: '24px',
    alignItems: 'center',
    '& label': {
      fontWeight: 'bold'
    }
  },

  ['form-ctrl']: {
    width: '100%'
  },

  primaryButton: {
    marginTop: '64px !important',
    width: '192px'
  }
});
